import $ from 'jquery';
window.$ = window.jQuery = $;

require('bootstrap/dist/js/bootstrap');
require('bootstrap/dist/js/bootstrap.bundle');
require('jquery.easing/jquery.easing');

// Temporary restore if svg code for some additional icon will be needed
// require('@fortawesome/fontawesome-free/js/fontawesome');
// require('@fortawesome/fontawesome-free/js/solid');
// require('@fortawesome/fontawesome-free/js/regular');

require('./navbar');
